const productDetails = {
  additionalDescription: {
    description: 'Beschreibung',
  },
  faq: {
    pregnancy: 'Was ist bei der Einnahme in der Schwangerschaft und Stillzeit zu beachten?',
    howDoesItWork: 'Wie wirkt Hamamelis?',
    sideEffects: 'Welche Nebenwirkungen hat Hametum Hämorrhoiden Salbe?',
    questionsAndAnswers: 'Fragen und Antworten zu Hametum Hämorrhoiden Salbe',
    package: 'ametum Hämorrhoidensalbe: Beipackzettel',
  },
  packaging: {
    packSize: 'Packungsgröße',
    amount: 'Menge',
    price: 'Preis',
    vatIncluded: 'inkl. MwSt.',
    uploadToPreorder: 'Laden Sie ein Rezept hoch, um dieses Produkt vorzubestellen.',
    contactPharmacy: 'Preis und Verfügbarkeit dieses Produkts erfahren Sie auf Anfrage in Ihrer Apotheke.',
    pricesMayVary: 'Preise variieren je nach Apotheke. Preis-Information erfolgt nach Apothekenauswahl.',
    uploadEPrescription: 'E-Rezept hochladen',
  },
  cta: {
    addToCart: 'In den Warenkorb',
    productInquiry: 'Anfrage',
    choosePharmacy: 'Apotheke wählen',
    prescriptionUpload: '(E-)Rezept hochladen',
  },
  video: 'Video',
  characteristics: 'Eigenschaften',
}

export default productDetails
